import { graphql, HttpResponse } from 'msw'
import {
  type EnrollmentVerifyPhoneData,
  type EnrollmentVerifyPhoneOtpSubmitOutput,
} from '../../../models/enrollment/generic/verify-phone'

export const getEnrollmentVerifyPhoneDataMock: EnrollmentVerifyPhoneData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/hycs/verify-phone',
  enrollmentData: {
    applicationId: '1234',
    phoneNumber: '+1 (987) 654-3210',
  },
}

export const submitEnrollmentVerifyPhoneDataMock: EnrollmentVerifyPhoneOtpSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/hycs/personal-info',
  enrollmentData: {
    applicationId: '1234',
    phoneNumber: '+1 (987) 654-3210',
  },
}

export const mockGetEnrollmentVerifyPhoneData = graphql.mutation('getEnrollmentVerifyPhoneData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentVerifyPhoneDataMock } })
})

export const mockSubmitEnrollmentVerifyPhoneData = graphql.mutation('submitEnrollmentVerifyPhoneData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentVerifyPhoneDataMock } })
})

export const mockEnrollmentVerifyPhone = [mockGetEnrollmentVerifyPhoneData, mockSubmitEnrollmentVerifyPhoneData]
